import React, { isValidElement, ReactNode } from 'react'

interface SlotProps {
    slot: string
    children: ReactNode | ReactNode[]
}

export const Slot: React.FC<SlotProps> = ({ slot, children }) => {
    return React.Children.toArray(children).filter(
        (child) => isValidElement(child) && (child.props as SlotProps).slot === slot
    )
}

export const SlotContent: React.FC<SlotProps> = ({ slot, children }) => {
    return React.Children.toArray(children).map((child) => {
        if (isValidElement(child)) {
            ;(child.props as SlotProps).slot = slot
        }

        return child
    })
}
